import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Lock, Mail } from 'lucide-react';

const LOGIN_BG = "https://images.unsplash.com/photo-1770573319051-c7e63d956d8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcGElMjBzYXVuYSUyMGVtcHR5JTIwcm9vbSUyMHdhcm0lMjBsaWdodHxlbnwwfHx8fDE3NzY0MDE5MjV8MA&ixlib=rb-4.1.0&q=85";

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/panel', { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/panel');
    } catch (err) {
      setError(typeof err === 'string' ? err : 'Error al iniciar sesion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cover bg-center relative" style={{ backgroundImage: `url(${LOGIN_BG})` }}>
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-10 w-full max-w-md mx-4 animate-fade-in">
        <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-10">
          <div className="text-center mb-8">
            <div className="w-14 h-14 bg-orange-700 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-outfit font-bold text-xl">CS</span>
            </div>
            <h1 className="font-outfit text-3xl font-semibold text-stone-900 tracking-tight" data-testid="login-title">Club Sauna</h1>
            <p className="text-stone-500 mt-1 text-sm">Sistema de Administracion</p>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl mb-6 text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label className="text-stone-700 text-sm font-medium">Correo electronico</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
                <Input
                  data-testid="login-email"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="correo@ejemplo.com"
                  className="pl-10 rounded-xl border-stone-300 focus:ring-orange-600/20 focus:border-orange-600"
                  required
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-stone-700 text-sm font-medium">Contrasena</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
                <Input
                  data-testid="login-password"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Ingresa tu contrasena"
                  className="pl-10 rounded-xl border-stone-300 focus:ring-orange-600/20 focus:border-orange-600"
                  required
                />
              </div>
            </div>
            <Button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-orange-700 hover:bg-orange-800 text-white rounded-full h-11 font-medium transition-all shadow-sm hover:shadow-md active:scale-[0.98]"
            >
              {loading ? 'Ingresando...' : 'Ingresar'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
